import { useEffect, useRef, useState } from 'react';

/** Instante actual que se refresca cada `ms` (para cronómetros y "ahora" en el programa). */
export function useAhora(ms = 1000, activo = true): number {
  const [ahora, setAhora] = useState(() => Date.now());
  useEffect(() => {
    if (!activo) return;
    setAhora(Date.now());
    const id = setInterval(() => setAhora(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms, activo]);
  return ahora;
}

/** Ancho en px de un elemento (para gráficas SVG que no escalan el texto). */
export function useAncho<T extends HTMLElement>(inicial = 640) {
  const ref = useRef<T>(null);
  const [ancho, setAncho] = useState(inicial);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setAncho(el.clientWidth || inicial);
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(([e]) => setAncho(Math.max(240, Math.round(e.contentRect.width))));
    ro.observe(el);
    return () => ro.disconnect();
  }, [inicial]);
  return [ref, ancho] as const;
}
